export default __webpack_public_path__ + "static/media/sheep-black-curve.e96ac0b2.jpeg";